export const getHighlightPkeyFromLocation = (history) => {
	const location = history?.location;
	if (!location) {
		return null;
	}
	const searchParams = new URLSearchParams(location.search || '');
	const searchPkey = searchParams.get('pkey');
	if (searchPkey != null && searchPkey !== '') {
		const parsed = Number(searchPkey);
		return Number.isNaN(parsed) ? null : parsed;
	}
	const hash = location.hash || '';
	if (hash.includes('pkey=')) {
		const queryString = hash.includes('?') ? hash.split('?')[1] : hash.replace(/^#/, '');
		const params = new URLSearchParams(queryString);
		const pkey = params.get('pkey');
		if (pkey != null && pkey !== '') {
			const parsed = Number(pkey);
			return Number.isNaN(parsed) ? null : parsed;
		}
	}
	return null;
};

export const getAvCenterTabFromLocation = (history, defaultTab = 'renewal_removals') => {
	const hash = history?.location?.hash || '';
	if (!hash || hash === '#') {
		return defaultTab;
	}
	const tabPart = hash.includes('?') ? hash.split('?')[0] : hash;
	const tab = tabPart.replace(/^#/, '');
	return tab || defaultTab;
};

export const syncCollectionFetchPage = (component, state) => {
	component.state.sorted = state?.sorted || [];
	if (state && typeof state.page === 'number') {
		component.state.page = state.page;
	} else if (!state) {
		component.state.page = 0;
	}
};

export const applyHighlightFilter = (component, filter) => {
	const highlightPkey = getHighlightPkeyFromLocation(component.props.history);
	if (highlightPkey) {
		filter.highlight_pkey = highlightPkey;
	} else {
		delete filter.highlight_pkey;
	}
	return highlightPkey;
};

export const getCollectionHighlightTrProps = (highlightRow, rowRefs) => (state, rowInfo) => {
	const pkey = rowInfo?.original?.pkey;
	const highlighted = pkey != null && Number(pkey) === Number(highlightRow);
	return {
		ref: (el) => {
			if (pkey != null && el) {
				rowRefs[pkey] = el;
			}
		},
		style: {
			background: highlighted ? '#fff3cd' : undefined,
		},
	};
};

export const applyCollectionRowHighlight = (component, data = component.state.data) => {
	const pkey = component.state.highlightRow;
	if (!pkey) {
		return;
	}
	const rows = Array.isArray(data) ? data : [];
	const matchIndex = rows.findIndex((row) => Number(row.pkey) === Number(pkey));
	const nextState = {};
	if (matchIndex >= 0) {
		if (component.state.filter?.highlight_pkey) {
			nextState.page = 0;
		} else if (component.state.limit) {
			nextState.page = Math.floor(matchIndex / component.state.limit);
		}
	}
	component.setState(nextState, () => {
		const row = component.rowRefs?.[pkey];
		if (row && typeof row.scrollIntoView === 'function') {
			row.scrollIntoView({behavior: 'smooth', block: 'center'});
		}
	});
};
